import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { adminActions } from '@src/store/reducers/adminReducer';

export const createAdminMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [adminActions.GET_CONFIGURATION]:  async (action: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Configuration`);
            const data = response.data;
            next({ type: action.type, payload: data });
            return data;
        },
        [adminActions.SAVE_CONFIGURATION]:  async (action: any) => {
            try {
                const response = await http.post(`${restServiceUrl}Configuration`, action.payload.configuration);
                return response.data;
            } catch {
            }
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/admin.middleware.ts